<template>
  <div class="">
    <sticky class="page-header sticky-page-heade page-header--new"
            :bigTotal="bigTotal"
            :loading="loading" :total="total"
            :label="'Rappel'">
      <router-link slot="dropdown-content" :to="{name: 'ReminderCreate'}"
                    class="dropdown-item">
        <span class="icon"><i class="fas fa-plus-circle"></i></span>
        <span>Nouveau rappel</span>
      </router-link>
      <a @click="loadItems()" class="dropdown-item" slot="dropdown-content">
        <span class="icon"><i class="fas fa-sync"></i></span>
        <span>Actualiser données</span>
      </a>
    </sticky>
    <div class="page-content columns collapseColumn collapseColumn--left collapseColumn--alignStart" id="columns-collapse"
         :class="opened ? 'is-active-collapse' : 'is-inactive-collapse'">
      <div class="column is-4 is-3-widescreen is-3-fullhd">
        <list-filter @resetFilters="resetFilters"
                     @changeFilters="changeFilters"
                     :total="total"
                     :bigTotal="bigTotal"
                     :loading="loading"
                     :hasFilter="hasFilter"
                     @opened="opened = !opened">
          <div class="columns">
            <div class="column is-paddingless-bottom">
              <label class="label">Nom/Prénom de l'utilisateur</label>
              <div class="control">
                <input @input="inputChange" v-model="filters.contact_name" class="input" type="text">
              </div>
            </div>
          </div>
          <div class="columns" v-if="isAdmin">
            <div class="column is-paddingless-bottom">
              <label class="label">Nom/Prénom de l'auteur</label>
              <div class="control">
                <input @input="inputChange" v-model="filters.author_name" class="input" type="text">
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <label class="label">Date</label>
              <div class="control">
                <flat-pickr @input="updateRangeDateFilter"
                            :config="configDate" @on-open="rangeDateOpened = true" @on-close="rangeDateClosed = true"
                            v-model="range_date" class="input" name="rangeDate"
                            :class="{'is-danger': errors.has('rangeDate')  && rangeDateOpened && rangeDateClosed}"
                            v-validate="'required'" data-vv-as="Période de rendez-vous"></flat-pickr>
              </div>
            </div>
          </div>
        </list-filter>
      </div>
      <div class="column is-8 is-9-widescreen is-9-fullhd">
        <div class="is-border">
          <div class="columns is-gapless row-width-actions-bar is-border-bottom">
            <transition enter-active-class="animated fadeIn faster" leave-active-class="animated fadeOut faster" mode="out-in">
              <div class="column is-narrow has-bg-primary columns is-vcentered is-gapless" v-if="hasFilter && !loading && total !== bigTotal">
                <div class="column is-padding-left is-padding-right has-text-white">Résultat : {{total || 0}} rappel(s)</div>
              </div>
            </transition>
            <div class="column"></div>
          </div>
          <div class="column has-bg-light is-paddingless-top is-paddingless-bottom">
            <div class="columns is-gapless is-padding-left is-padding-right is-vcentered">
              <div class="column">
                <pagination :loading="loading" @ChangePage="currentPage = $event" :currentPage="currentPage"
                            :totalPage="totalPage" :reverse="true"></pagination>
              </div>
            </div>
          </div>
          <table-h-scroll :has-sticky="true" :sticky-styles="stickyStyles"
                          :sticky-datas="stickyDatas" :reload-controls="loading && items.length">
            <table v-show="!loading && items.length" class="table is-fullwidth is-first-fixed-small is-last-fixed-small is-marginless-bottom is-narrow is-striped-v is-marginless-bottom has-actionsontd">
              <thead>
              <tr class="is-size-6">
                <th>
                  <sortable @sort="sort('title', $event)" :sort="sortBy.title" label="Titre"></sortable>
                </th>
                <th>
                  <sortable @sort="sort('note', $event)" :sort="sortBy.note" label="Note"></sortable>
                </th>
                <th v-if="isAdmin">
                  <sortable @sort="sort('author_name', $event)" :sort="sortBy.author_name" label="Auteur"></sortable>
                </th>
                <th>
                  <sortable @sort="sort('user_name', $event)" :sort="sortBy.author_name" label="Utilisateur"></sortable>
                </th>
                <th>
                  <sortable @sort="sort('date', $event)" :sort="sortBy.author_name" label="Date"></sortable>
                </th>
                <th class="has-text-centered is-narrow">Actions</th>
              </tr>
              </thead>
              <tbody>
                <tr v-for="c in items" :key="c.pk" v-if="items && items.length" class="is-size-6">
                  <td class="is-narrow">{{c.title}}</td>
                  <td><span v-if="c.note">{{c.note}}</span><span v-else>-</span></td>
                  <td class="is-narrow" v-if="isAdmin"><router-link :to="{name: 'UserVue', params: {id: c.author}}">{{c.author_name || '-' | smallName}}</router-link></td>
                  <td class="is-narrow"><router-link :to="{name: 'UserVue', params: {id: c.user}}">{{c.user_name || '-' | smallName}}</router-link></td>
                  <td class="is-narrow">{{c.date | prettyDatetime}}</td>
                  <td class="has-text-centered actions">
                    <button class="button is-circle is-small" @click="deleteItem(c.pk)">
                      <i class="fal fa-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-show="!loading && !items.length">
              <div class="columns">
                <div class="column">
                  <h2 class="title is-3 has-text-weight-bold">Aucun Rappel disponible</h2>
                  <a class="has-text-primary" @click="resetFilters" v-if="hasFilter"><span class="icon is-small"><i class="fal fa-undo-alt"></i></span> <span>Réinitialiser les filtres</span></a>
                </div>
              </div>
            </div>
            <div class="columns is-gapless is-padding-left is-padding-right is-vcentered" v-if="!loading">
              <div class="column">
                <pagination :loading="loading" @ChangePage="currentPage = $event" :currentPage="currentPage"
                            :totalPage="totalPage" :reverse="true"></pagination>
              </div>
            </div>
          </table-h-scroll>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { Sort, Filter, GenericList, TableHeaderSticky } from '../../mixins'
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'ReminderList',
    mixins: [GenericList, TableHeaderSticky, Sort, Filter],
    data () {
      return {
        actionButtons: [
          {
            linkClass: ['button', 'is-white'],
            icon: ['fa-plus-square'],
            action: () => {
              this.newReminder()
            },
            text: 'Nouveau Rappel'
          },
          {
            linkClass: ['button', 'is-white'],
            icon: ['fa-sync'],
            action: () => {
              this.loadItems()
            }
          }
        ],
        loadDocuments: this.loadItems,
        service: this.$api.reminderService,
        configDate: {
          altFormat: 'j/m/Y',
          altInput: true,
          dateFormat: 'd/m/Y',
          mode: 'range'
        },
        rangeDateOpened: false,
        rangeDateClosed: true,
        opened: true,
        range_date: null
      }
    },
    computed: {
      ...mapState(['quickview']),
      ...mapGetters(['isAdmin'])
    },
    watch: {
      quickview ({mode, params, results}) {
        if (results) {
          if (mode === 'NEW_REMINDER') {
            this.loadItems()
          }
        }
      }
    },
    methods: {
      updateRangeDateFilter (e) {
        let range = e.split(' au ')
        this.$set(this.filters, 'start_date__gte', range[0])
        if (range.length > 0) this.$set(this.filters, 'end_date__lte', range[1])
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      newReminder () {
        this.$store.commit('setQuickview', {mode: 'NEW_REMINDER'})
      }
    },
    created () {
      this.loadItems()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/reminder/ReminderList.vue